/** Private beta participation agreement. Replace this copy if counsel supplies a superseding text. */

export const AGREEMENT_TITLE = "REChecklist Private Beta Participation Agreement";

export const AGREEMENT_SECTIONS = [
  {
    heading: "1. Invitation and purpose",
    paragraphs: [
      "You have been personally invited to participate in a confidential, invitation-only early-access evaluation of REChecklist (the “Beta”). The Beta exists so that a trusted agent or broker may use the working desk as if it were already theirs, enter real professional work at their discretion, and provide honest feedback that will shape the product.",
      "Participation is free of charge for the duration of this private Beta. This Agreement is a click-accept contract. Selecting “Accept & Continue” constitutes your signature and your consent to the terms below.",
    ],
  },
  {
    heading: "2. Confidentiality",
    paragraphs: [
      "The Beta, including unreleased features, workflows, copy, design, defects, and performance, is confidential. You agree not to publish, post, record, livestream, screenshot for public distribution, or otherwise disclose the Beta or your evaluation of it to the press, social media, competing products, or any person who has not been expressly invited by DreamHome Journey.",
      "You may discuss the Beta with colleagues inside your own office only to the extent necessary to use it in real client work, and only if those colleagues understand that the software is confidential early access.",
    ],
  },
  {
    heading: "3. License to use",
    paragraphs: [
      "DreamHome Journey grants you a personal, non-exclusive, non-transferable, revocable license to use the Beta solely for evaluation and legitimate real-estate workflow during the Beta period. You may not sublicense, reverse engineer, scrape, or present the Beta as a finished public product of your own.",
      "The Beta is an early-access version. Features may change, pause, or be withdrawn. Data on this prototype is stored locally on the device in a swap-ready model pending a hosted server.",
    ],
  },
  {
    heading: "4. Feedback",
    paragraphs: [
      "You agree to provide honest, timely feedback through the REChecklist messaging feature. Feedback may include observations, suggestions, defect reports, and impressions of tone, clarity, and usefulness.",
      "You grant DreamHome Journey a worldwide, royalty-free, irrevocable license to use, copy, modify, and incorporate your feedback into REChecklist and related materials without further obligation to you. Feedback messages are tagged as beta feedback and stored for the program administrators.",
    ],
  },
  {
    heading: "5. Client information",
    paragraphs: [
      "You are invited to use the Beta with real client information if that is how you will evaluate whether the desk is a pleasure to use. You remain solely responsible for client confidentiality, brokerage policy, and any duty you owe under law or your office’s supervision.",
      "Do not enter information you are not authorized to hold. DreamHome Journey does not become the custodian of your client relationships by hosting this early-access desk.",
    ],
  },
  {
    heading: "6. Professional standing",
    paragraphs: [
      "REChecklist is a workflow companion. It is not a California Department of Real Estate license, a legal opinion, or a substitute for your brokerage’s compliance program. License numbers recorded in a profile are recorded for the desk; they are not a certification by DreamHome Journey or REChecklist.",
    ],
  },
  {
    heading: "7. As-is software",
    paragraphs: [
      "The Beta is provided as-is. DreamHome Journey makes no warranty that the Beta will be uninterrupted, error-free, or fit for a particular closing. You use it with the understanding that early-access software may contain gaps, and that your feedback is how those gaps are found.",
    ],
  },
  {
    heading: "8. Term and withdrawal",
    paragraphs: [
      "This invitation may be withdrawn at any time. You may stop using the Beta at any time. Upon request, you will cease use of the early-access desk and treat remaining confidential materials as confidential.",
      "Sections 2, 4, 5, 6, and 7 survive the end of the Beta.",
    ],
  },
  {
    heading: "9. Acceptance",
    paragraphs: [
      "By selecting “Accept & Continue,” you confirm that you have read this Agreement, that you are the invited agent or broker (or are authorized to bind that person), and that a timestamp of your acceptance will be stored with your Beta profile.",
    ],
  },
];
